export default __webpack_public_path__ + "static/media/default-location-new.565d5f3e.svg";